export default __webpack_public_path__ + "static/mid4a-44b6502ba10c3f9661f8606a557b6eaa.png";